import { render, staticRenderFns } from "./is-loading.vue?vue&type=template&id=aedffa4a&scoped=true&"
import script from "./is-loading.vue?vue&type=script&lang=js&"
export * from "./is-loading.vue?vue&type=script&lang=js&"
import style0 from "./is-loading.vue?vue&type=style&index=0&id=aedffa4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedffa4a",
  null
  
)

export default component.exports